module.exports = __webpack_public_path__ + "img/Grupo 180@2x.12722172.png";